const RileylolFeaturesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5VZmNX2MMsCG3TXkG3IunL?si=519686df46354a69" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>notamachine - broken (feat. Kawaii Ry & rileylol)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/sadoutwest/yng-spike-sos-feat-sadoutwest" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-BLLGwZvI5ha0qVQH-p41GSw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yng Spike - SOS (feat. rileylol) *2021*</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2m5E7Z01E0oMrtqxUSUYhS?si=b6cedfc1e9dc4cdd" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-nZHypsKCH9WPzk4z-44ObSQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Don't Try It (feat. rileylol)</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3eD07yn0xIZCEux6CvequI?si=ad02750dffae4b97" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Twizzy (feat. rileylol)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5Y3RT0cNWDm32BCFpEbCOu?si=dfd67e4cdf9f41f1" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - 40 (feat. rileylol)</strong><br/>
                (prod. gotti)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature / Music Video</p>
            <a href="https://www.youtube.com/watch?v=viEzTBEkDMw" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-5e8PhdPzzuuG8twL-xaG7Lg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hyder Daze - idontwannaseeyou (feat. rileylol)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/nervous-w-benzohart-rileylol-xmichaelwarren" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Wz12ivW4gfUczeBO-42Q0cw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - nervous (feat. benzohart & rileylol)</strong><br/>
                (prod. xmichaelwarren)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2rx5ydmVzkZQQGAwa68JPP?si=5d3e42aeb28e4b05" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-m2uJNVg5hpzJytsP-JZByxA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - Fuck An Edible (feat. 3miles, toph & rileylol)</strong><br/>
                (prod. Rhine & Nick Mira)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/6U7ABtu86SSM9cJbb3K4Yt?si=fcef54db85cd499d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-m2uJNVg5hpzJytsP-JZByxA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - IOA Cypher (feat. 3miles, Dreoh, rileylol, CloudGTB, toph, & Jodom)</strong><br/>
                (prod. Masetheworst)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/madara-tn/weekend-ft-33life-sadoutwest-prod-jodom-lukrative" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-DzzNJ09rJ9EFLzce-naiQkw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Madara TBH - Weekend (feat. rileylol & 33life)</strong><br/>
                (prod. Jodom & Lukrative)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/madara-tn/04-stop-the-count-feat-sadoutwest-3miles-prod-dara-x-bart-how-x-synthetic" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-93Wt7LrmXh8ySxXz-kQY0CQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Madara TBH - Stop the Count (feat. rileylol & 3miles)</strong><br/>
                (prod. Madara TBH, Bart How & Synthetic)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/that-girl-w-sadoutwest" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-7uRS5SpXZlcol5ni-OxzWhw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - that girl (feat. rileylol)</strong><br/>
                (prod. tenfifty)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/uglyboy4/punisher-tee-w-sadoutwest-prod-uglyboy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qpWBQesLJJNtSR9v-zRySUw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>uglyboy - punisher tee (feat. rileylol)</strong><br/>
                (prod. uglyboy)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/icedoutangels/all-alone-ft-3miles-toph-sadoutwest-prod-mason-wu-tommi-oslo-masetheworst" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qPWQWtRtLQxbqZhz-c5FGEw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>IcedOutAngels - All Alone (feat. 3miles, toph & rileylol)</strong><br/>
                (prod. Mason Wu, Tommi Oslo & Masetheworst)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/caswhale/wangs-ft-sadoutwest-prod-tommi-oslo-x-nxah" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yvAy5K1mzZJ3s2G9-jxVdiw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>caswhale - Wangs (feat. rileylol & Malachai)</strong><br/>
                (prod. tommi oslo & nxah)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/pieces-feat-sadoutwest-malachai-yung-cris" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XKr0rZNUqckQ4eMw-mWC63w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - Pieces (feat. rileylol & Malachai)</strong><br/>
                (prod. Yung Cris)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/plastic-feat-sadoutwest-curtains" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XKr0rZNUqckQ4eMw-mWC63w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - Plastic (feat. rileylol)</strong><br/>
                (prod. Curtains)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/99-feat-sadoutwest-prod-dj-khaleds-son" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000651430360-p05b1h-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - 99 (feat. rileylol)</strong><br/>
                (prod. DJ Khaled's Son)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/solarsage/run-away-feat-sadoutwest" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000629028214-o9h4nn-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SolarSage - Run Away (feat. rileylol)</strong>
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/falling-2-feat-sadoutwest-prod-y-axis" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000613231057-imesvj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - hello kitty (feat. playwithguns, rileylol, wristcry, yung krypto & 1ondon)</strong><br/>
                (prod. solsa)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/weight/falling-2-feat-sadoutwest-prod-y-axis" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000590134970-n9lmk0-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lucas2k - falling 2 (feat. rileylol)</strong><br/>
                (prod. y axis)
              </p>
            </a>
          </div> 

        </div>
      </>
    );
  };
  export default RileylolFeaturesStatic;